module.exports = __webpack_public_path__ + "static/turquia-018-83dc3d03366b0eb9391ed59dea5d4c4b.jpg";